import React from 'react';
import Propagator from '../../Propagator';
import { Mutation } from 'react-apollo';
import gql from 'graphql-tag';

const DELETE_GAME_MUTATION = gql`
	mutation($gameID: ID!) {
		deleteGame(gameID: $gameID) {
			id
		}
	}
`;

export default ({ children }) => (
	<Mutation mutation={DELETE_GAME_MUTATION}>
		{deleteGame => Propagator(children, deleteGame)}
	</Mutation>
);
